import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {
  BaseComponent,
  FilterModel, GLOBAL,
  LanguagesQuery,
  LeModalService,
  UserQuery,
  UsersQuery
} from "common-shared";
import {UserEditModalComponent} from "web-shared";
import {map, takeUntil} from "rxjs/operators";
import {StateService} from "web-shared";
import {BehaviorSubject, combineLatest, Observable} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import {Table} from "primeng/table";
import {ResourceService} from "../../../manufacturing/resources/resource.service";
import {ResourceModel} from "../../../manufacturing/resources/models/resource.model";

@Component({
  selector: 'app-system-user-list',
  templateUrl: './user-list.component.html'
})
export class UserListComponent extends BaseComponent implements OnInit {
  filter$: BehaviorSubject<FilterModel<UserQuery>>;
  users$: Observable<UserQuery[]>;
  offset: number = 0;
  @ViewChild(Table) table: Table;

  constructor(public usersQuery: UsersQuery, public languagesQuery: LanguagesQuery, private modalService: LeModalService, private state: StateService, private activatedRoute: ActivatedRoute, private changeDetector: ChangeDetectorRef, private resourceService: ResourceService) {
    super();
  }

  ngOnInit() {
    this.restoreFilterState();
  }

  ngAfterViewInit() {
    this.changeDetector.detach();
    this.configureFilter();
    this.changeDetector.detectChanges();
    this.changeDetector.reattach();
  }

  private restoreFilterState() {
    const filterState = this.state.getFilterState<UserQuery>() || new FilterModel<UserQuery>({Data: new UserQuery(), AdvancedFilter: this.activatedRoute.routeConfig.data['search'].initialStateOfAdvanced});
    this.filter$ = new BehaviorSubject<FilterModel<UserQuery>>(filterState);
  }

  private configureFilter() {
    this.users$ = combineLatest(
      [this.usersQuery.getAll$, this.filter$]
    ).pipe(map(([users, filter]) => {
      this.offset = 0;
      this.state.setFilterState(filter);
      this.table?.filterGlobal(filter.Global, 'contains');
      if (filter.Data.LanguageId) {
        this.table?.filter(filter.Data.LanguageId, 'LanguageId', 'equals');
      }
      if (filter.Data.IsDeleted === true || filter.Data.IsDeleted === false) {
        this.table?.filter(filter.Data.IsDeleted, 'IsDeleted', 'contains');
      }
      return users;
    }));
  }

  edit(id: string = null) {
    let content = this.modalService.show(UserEditModalComponent, {initialState: {entityId: id}}).content;
    content.add.pipe(takeUntil(this.componentDestroyed)).subscribe(user => {
      const parts = (user.Fullname ?? user.Email).toUpperCase().split(' ');
      const userResource = ResourceModel.CreateDefault({
        KindClv: GLOBAL.Classificators.ResourceKind.Person,
        Code: parts.shift() + parts.map(part => part.slice(0, 1)).join(''),
        Name: user.Fullname ?? user.Email,
        User: user
      });
      this.resourceService.addNew(userResource).pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
          content.close(value.UserId);
        }
      );
    })
    content.onHide$.pipe(takeUntil(this.componentDestroyed));
  }

  updateFilter($event) {
    if ($event.filters?.IsDeleted) {
      let filter = this.state.getFilterState<UserQuery>();
      filter.Data.IsDeleted = $event.filters.IsDeleted.value;
      this.state.setFilterState(filter);
    }
  }
}
